import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PaywallService } from '../../../paywall/services/paywall.service';
import { SubscriptionFlowService } from '../services/subscription-flow.service';

export const subscriptionErrorGuard: CanActivateFn = (route, state) => {
  const flow = inject(SubscriptionFlowService);
  const router = inject(Router);
  const paywall = inject(PaywallService);

  const canActivate: boolean =
    paywall.hasError() || (flow.isFlowActive() && !flow.isPendingActivation() && !flow.isPendingVerification());

  return canActivate ? true : router.createUrlTree(['/subscription/upgrade']);
};
